import { message } from "antd";
import { LgButton } from "lancoo-web-ui";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setLoginShow, setUserId } from "../../../store/reducers/userInfo";
import './index.scss';

function SelectLoginUser(props: any) {

    const {
        data = [],
        phone,
        setIsloading
    } = props;

    const dispatch = useDispatch();

    const [selected, setSelected] = useState<any>("");

    useEffect(() => {
        // 选上上次登录的账号
        setSelected(data.find((ele: any) => ele.isLastLogin)?.idCard || data?.[0]?.idCard || '')
    }, []);


    const login = () => {
        // 登陆
        message.success("登陆成功");
        dispatch(setUserId(selected));
        dispatch(setLoginShow(false));
    }

    return (
        <div id="selectUser">
            <div>
                <div style={{
                    color: '#acacac',
                    marginBottom: 10
                }}>{`您的手机号${phone?.substring(0, 3) + '****' + phone?.substring(phone?.length - 4)}绑定了多个账户，请选择需要登录的账户`}</div>
                <div className="content_user">
                    {
                        data?.length > 0 && data.map((ele, index) => {
                            return <div key={index}>
                                <div className={`radio-item ${selected === ele.idCard ? 'selected' : ''}`} onClick={() => setSelected(ele.idCard)}>
                                    <span className="image"></span>
                                    <div className="userImage"></div>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-around'
                                    }}>
                                        <div>
                                            <span style={{
                                                display: 'inline-block',
                                                maxWidth: ele.isLastLogin ? 180 : 200,
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden',
                                                fontSize: 15
                                            }}
                                                title={(ele.username || '--')}
                                            >
                                                {ele.username || '--'}
                                            </span>
                                            <span style={{
                                                display: 'inline-block',
                                                maxWidth: ele.isLastLogin ? 70 : 90,
                                                marginLeft: 5,
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden',
                                                color: '#b4b4b4'
                                            }}
                                                title={ele.name || '--'}
                                            >
                                                {'(' + (ele.name || '--') + ')'}
                                            </span>
                                        </div>
                                        <div style={{ color: '#b4b4b4' }}>
                                            {ele.idCard || '--'}
                                        </div>
                                        {ele.isLastLogin && <div style={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            backgroundColor: '#fceee5',
                                            display: 'inline-block',
                                            marginLeft: 5,
                                            width: 55,
                                            height: 20
                                        }}
                                        >
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: 12,
                                                color: '#ff7316',
                                                height: 20
                                            }}>
                                                上次登录
                                            </div>
                                        </div>}
                                    </div>

                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
            <LgButton
                className="login_btn"
                onClick={login}
                backgroundType='opacification'
                type='info'
                size="default"
                style={{ justifyContent: 'center', width: 200 }}
            >
                确定
            </LgButton>
        </div>
    )
}

export default SelectLoginUser